import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { browserCalendarToday, isAllowedDueDate } from "./assessment_task_date.util";

export const TASK_DESCRIPTION_MAX_CHARACTERS = 4000;
export const TASK_DESCRIPTION_MAX_BYTES = 16000;
export const TASK_DESCRIPTION_MAX_CODE_UNITS = TASK_DESCRIPTION_MAX_CHARACTERS * 2;
export const TASK_REQUIREMENT_MAX_COUNT = 1000;
export const TASK_ASSIGNEE_MAX_COUNT = 500;

export const taskDescriptionValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (typeof value !== "string" || !value.trim()) return { required: true };
    let characters = 0;
    for (const character of value) {
        const codePoint = character.codePointAt(0)!;
        if (codePoint === 0 || (codePoint >= 0xd800 && codePoint <= 0xdfff)) {
            return { invalidCharacter: true };
        }
        if (++characters > TASK_DESCRIPTION_MAX_CHARACTERS) return { maxlength: true };
    }
    return new TextEncoder().encode(value).length > TASK_DESCRIPTION_MAX_BYTES
        ? { maxbytes: true } : null;
};

export function taskSelectionValidator(maximum: number, allowEmpty = false): ValidatorFn {
    return (control) => {
        const values: unknown = control.value;
        if (!Array.isArray(values) || (!allowEmpty && values.length === 0)) return { required: true };
        return values.length > maximum || new Set(values).size !== values.length
            ? { invalidSelection: true } : null;
    };
}

export function taskDueDateValidator(unchangedDueDate: () => string | null): ValidatorFn {
    return (control) => {
        const value: unknown = control.value;
        if (value === null || value === "") return null;
        if (typeof value !== "string") return { invalidDate: true };
        if (value === unchangedDueDate()) return null;
        return isAllowedDueDate(value, unchangedDueDate()) ? null : { futureDate: true };
    };
}

export function nextBrowserCalendarDate(now: Date = new Date()): string | null {
    if (Number.isNaN(now.getTime())) return null;
    const tomorrow = new Date(now.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);
    return browserCalendarToday(tomorrow);
}
